module.exports = __webpack_public_path__ + "assets/img/F1.29b06d7e.png";